export const GET_ROLE = 'GET_ROLE'

export const updateRole = (role) => {
  localStorage.setItem('ROLE_ORG', role)
  return {
    type: GET_ROLE,
    payload: {
      role
    }
  }
}

export const restoreRole = () => {
  const org_id = localStorage.getItem('ROLE_ORG')
  return {
    type: GET_ROLE,
    payload: {
      role: org_id
    }
  }
}
